import Cookies from 'js-cookie';

const TokenKey = 'loupan-crm-token';
const TokenUploadSecret = 'loupan-upload-secret';
const userPermissions = 'loupan-permission';
const userCompanyInfo = 'loupan-userCompanyInfo';
const userInfo = 'loupan-userInfo';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 用户权限列表
export function getPermission() {
  return JSON.parse(localStorage.getItem(userPermissions) || '[]');
}

export function setPermission(data) {
  return localStorage.setItem(userPermissions, JSON.stringify(data));
}

export function removePermission() {
  return Cookies.remove(userPermissions)
}

// 登录临时秘钥:固定25分钟
export function setSecret (data) {
  const newDate = new Date();
  const expireDate = new Date(newDate.getTime() + 25 * 60 * 1000);
  Cookies.set(TokenUploadSecret, data, { expires: expireDate, path: '' });
}

export function getSecret () {
  return Cookies.get(TokenUploadSecret);
}
// 保存登录用户信息
export function getUserInfo() {
  return JSON.parse(localStorage.getItem(userInfo) || '{}');
}
export function setUserInfo(data) {
  return localStorage.setItem(userInfo, JSON.stringify(data));
}
// table列展示
export function getTableColumn(key) {
  return localStorage.getItem(key);
}
export function setTableColumn(key, data) {
  return localStorage.setItem(key, data);
}
